import { useModalDarkContext } from "@/components/context/ModalDarkContext"
import { useBreakpoints } from "@/components/screen"
import WebsiteTypography from "@/components/websiteTypography/WebsiteTypography"
import { scrollToSection } from "@/helpers/scrollToSection"
import FooterLegalNote from "@/pages/website-landing/components/footer/footer-legal-note/FooterLegalNote"
import FooterSocialButtons from "@/pages/website-landing/components/footer/footer-social-buttons/FooterSocialButtons"
import { websiteRoutes } from "@/router/routes"
import { EASETECH } from "@/utilities/global-variables"
import { Col, Row, Space } from "antd"
import { FC } from "react"
import { useParams } from "react-router"
import "./MobileFooter.less"

import { SvgIcon } from "@/components/icon"
import WebsiteButton from "@/components/website-button/WebsiteButton"
import { Link, useNavigate } from "react-router-dom"
import logoWhite from "../images/logo_company-white.png"

const { Text, Paragraph } = WebsiteTypography

const MobileFooter: FC = () => {
  const { isXxs } = useBreakpoints()
  const { openDarkModal } = useModalDarkContext()
  const navigate = useNavigate()
  const { website } = websiteRoutes

  const params = useParams()
  // The footer also renders on `/`, which has no :org param — fall back so links never become `/undefined/...`.
  const currentOrgSlug = params.org ?? EASETECH

  const onHomeClick = async () => {
    navigate(`/easetech${website.home}`)
  }
  const onPrivacyClick = () => {
    navigate(website.privacyPolicy)
  }
  const onTermsClick = () => {
    navigate(website.termsAndConditions)
  }
  const handleContactRequestClick = () => {
    openDarkModal({
      type: "quick-contact",
      isLogo: true,
    })
  }

  const onSoftwareSolutionsClick = async () => {
    navigate(`/easetech${website.software}`)
    await scrollToSection("software-solutions")
  }

  const onConsultingServicesClick = async () => {
    navigate(`/easetech${website.consulting}`)
    await scrollToSection("our-consulting-services")
  }

  return (
    <Row className={"footer-mobile-content"}>
      <Col span={24} style={{ paddingBottom: 26 }}>
        <Row className={"footer-mobile-logo"} justify={"center"} align={"middle"}>
          <Col className={"logo-wrapper"}>
            <img src={logoWhite} alt={""} />
          </Col>
        </Row>
      </Col>
      {/*Navigation*/}
      <Col span={24} style={{ paddingBottom: 24 }}>
        <Row className={"footer-mobile-buttons-block"} justify={"center"}>
          <Col span={14} md={14} sm={18} xs={24}>
            <Row justify={"space-between"} gutter={8}>
              <Col span={11} md={11} sm={11} xs={isXxs ? 24 : 12} style={{ marginBottom: isXxs ? 24 : 0 }}>
                <Space direction={"vertical"} size={"middle"} style={{ width: "100%", paddingBottom: 24 }}>
                  <Paragraph centered weight={"w700"} size={"xl"}>
                    {"Navigation"}
                  </Paragraph>

                  <WebsiteButton btnType={"text"} onClick={onHomeClick} style={{ width: "100%" }}>
                    <Text weight={"w700"} color={"website-secondary"} size={"lg"}>
                      {"Home"}
                    </Text>
                  </WebsiteButton>

                  <WebsiteButton btnType={"text"} onClick={handleContactRequestClick} style={{ width: "100%" }}>
                    <Text weight={"w700"} color={"website-secondary"} size={"lg"}>
                      {"Quick contact"}
                    </Text>
                  </WebsiteButton>
                </Space>
              </Col>

              <Col span={11} md={11} sm={11} xs={isXxs ? 24 : 12}>
                <Space direction={"vertical"} size={"middle"} style={{ width: "100%", paddingBottom: 24 }}>
                  <Paragraph centered weight={"w700"} size={"xl"}>
                    {"Our Services"}
                  </Paragraph>

                  <WebsiteButton btnType={"text"} onClick={onSoftwareSolutionsClick} style={{ width: "100%" }}>
                    <Text weight={"w700"} color={"website-secondary"} size={"lg"}>
                      {"Software Solution"}
                    </Text>
                  </WebsiteButton>

                  <WebsiteButton btnType={"text"} onClick={onConsultingServicesClick} style={{ width: "100%" }}>
                    <Text weight={"w700"} color={"website-secondary"} size={"lg"}>
                      {"Consulting Services"}
                    </Text>
                  </WebsiteButton>
                </Space>
              </Col>
            </Row>

            {/*SIGN IN, REGISTER*/}
            <Row justify={isXxs ? "center" : "space-between"} gutter={8}>
              <Col span={11} md={11} sm={11} xs={isXxs ? 18 : 12} style={{ marginBottom: isXxs ? 24 : 0 }}>
                <WebsiteButton size={"large"} btnType={"primary"} block>
                  <Link to={`/${currentOrgSlug}${website.auth}/wayleave/client`}>
                    <Text size={"lg"}>{"REGISTER"}</Text>
                  </Link>
                </WebsiteButton>
              </Col>

              <Col span={11} md={11} sm={11} xs={isXxs ? 18 : 12} style={{ marginBottom: isXxs ? 24 : 0 }}>
                <WebsiteButton size={"large"} btnType={"ghost-white"} block>
                  <Link to={`/${currentOrgSlug}${website.auth}/wayleave/login`}>
                    <Text size={"lg"}>{"SIGN IN"}</Text>
                  </Link>
                </WebsiteButton>
              </Col>
            </Row>
          </Col>
        </Row>
      </Col>

      <Col span={24} style={{ paddingBottom: 24 }}>
        <Row justify={"center"}>
          <Col span={16}>
            <Paragraph centered weight={"w700"} size={"xl"}>
              {"Contact Us"}
            </Paragraph>
          </Col>
        </Row>
      </Col>

      <Col span={24}>
        <Row justify={"center"}>
          <Col span={14} md={14} sm={18} xs={22}>
            <Row justify={"space-between"}>
              <Col span={11} md={11} sm={11} xs={isXxs ? 24 : 12}>
                <Space
                  direction={"vertical"}
                  style={{ width: "100%", paddingBottom: 24 }}
                  className={"contact-items-space-wrapper"}
                >
                  <Paragraph
                    size={"md"}
                    lh={"lh-lg"}
                    color={"website-secondary"}
                    centered
                    className={"number-text-title"}
                    id={"phone-section"}
                  >
                    {"Phone:"}
                  </Paragraph>

                  <a href={"tel:+0826996888"} className={"contact-phone-mobile-item"}>
                    <SvgIcon type={"whatsapp"} color={"white"} />
                    <Paragraph
                      weight={"w700"}
                      size={"lg"}
                      className={"number-text"}
                      centered
                      style={{ letterSpacing: "2px" }}
                    >
                      {"082 699 6888"}
                    </Paragraph>
                  </a>

                  <a href={"tel:+0107454941"} className={"contact-phone-mobile-item"}>
                    <SvgIcon type={"phone"} color={"white"} />
                    <Paragraph
                      weight={"w700"}
                      size={"lg"}
                      className={"number-text"}
                      centered
                      style={{ letterSpacing: "2px" }}
                    >
                      {"010 745 4941"}
                    </Paragraph>
                  </a>
                </Space>
              </Col>

              <Col span={11} md={11} sm={11} xs={isXxs ? 24 : 12}>
                <Space direction={"vertical"} style={{ width: "100%" }}>
                  <Paragraph
                    size={"md"}
                    lh={"lh-lg"}
                    color={"website-secondary"}
                    className={"number-text-title"}
                    centered
                    style={{ width: "100%" }}
                  >
                    {"Email:"}
                  </Paragraph>

                  <a href={"mailto:info@easetech.co.za"} style={{ width: "100%" }}>
                    <Paragraph weight={"w700"} size={"lg"} color={"orange"} centered lh={"lh-sm"}>
                      {"info@easetech.co.za"}
                    </Paragraph>
                  </a>
                </Space>
              </Col>
            </Row>
          </Col>
        </Row>
      </Col>
      {/*Social media icons*/}
      <Col span={24} style={{ paddingBottom: 24 }}>
        <Row justify={"center"} style={{ paddingTop: isXxs ? 28 : 0 }}>
          <Col span={16} md={16} sm={16} xs={24} className={"soc-buttons-block"}>
            <Row justify={"center"}>
              <Col>
                <FooterSocialButtons />
              </Col>
            </Row>
          </Col>
        </Row>
      </Col>

      {/* terms and conditions*/}
      <Col span={24} style={{ paddingBottom: 36 }}>
        <Row justify={"center"}>
          <Col span={19} md={19} sm={19} xs={24} style={{ display: "flex", justifyContent: "center" }}>
            <FooterLegalNote />
          </Col>
        </Row>
      </Col>
    </Row>
  )
}

export default MobileFooter
